import React from 'react';
import '../styles/ContactSection.css';

const ContactSection = () => {
  // Função para disparar o evento do Pixel
  const handleContactClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact'); // Dispara o evento "Contact" no Pixel
    }
  };

  return (
    <div className="contact-section">
      <div className="text-box">
        <h2>Vamos criar uma marca?</h2>
        <p>Entre em contato comigo! Estou disposto a entender melhor o seu projeto.</p>
        <a
          href="https://wa.me/556196414079"
          target="_blank"
          rel="noreferrer"
          onClick={handleContactClick} // Chama a função ao clicar no link
        >
          <button className="button">Entre em Contato</button>
        </a>
      </div>
      <div className="image-box"></div>
    </div>
  );
};

export default ContactSection;
